module.exports = __webpack_public_path__ + "static/img/iconMrIbis.f33a71c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconMrIbis.svg
// module id = Z/cl
// module chunks = 1